import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { PageHero, CTABand, Reveal } from "@/components/ui-bits";
import { WHY_ORVELLA, WHO_WE_SERVE } from "@/lib/site";

const ICONS = {
  MapPin: true, Handshake: true, Ship: true, Package: true, MessagesSquare: true,
  SlidersHorizontal: true, LayoutGrid: true,
};

export default function WhyOrvella() {
  return (
    <>
      <Seo
        title="Why Orvella Overseas — B2B Food Sourcing Partner in India"
        description="India-based product sourcing, a B2B-focused approach, buyer-specific requirements, product diversity and export coordination — reasons international buyers work with Orvella Overseas."
        path="/why-orvella"
      />

      <PageHero
        eyebrow="Why Orvella"
        title="Why Work With Orvella Overseas?"
        sub="A sourcing partner structured for international B2B buyers — from first enquiry to shipment coordination."
      />

      <section className="section-pad">
        <div className="container-x grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {WHY_ORVELLA.map((w, i) => (
            <Reveal key={w.title} delay={i * 0.05}>
              <div className="card card-hover h-full p-7">
                <span className="font-serif text-3xl font-semibold text-gold-soft">{String(i + 1).padStart(2, "0")}</span>
                <h2 className="mt-3 font-serif text-xl font-semibold text-navy">{w.title}</h2>
                <p className="mt-2 text-sm leading-relaxed text-mist">{w.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="section-pad bg-sand">
        <div className="container-x">
          <Reveal>
            <span className="eyebrow">Who We Serve</span>
            <span className="mt-3 block h-[2px] w-12 bg-gold" />
            <h2 className="mt-5 font-serif text-3xl font-semibold text-navy">Designed Around International B2B Buyers</h2>
          </Reveal>
          <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {WHO_WE_SERVE.map((w, i) => (
              <Reveal key={w.title} delay={i * 0.04}>
                <div className="card h-full p-6">
                  <h3 className="font-bold text-navy">{w.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-mist">{w.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.1} className="mt-10">
            <Link to="/quote" data-testid="why-orvella-quote-btn" className="btn-gold">Request a Quote</Link>
          </Reveal>
        </div>
      </section>

      <CTABand />
    </>
  );
}
